import { createContext, useContext } from 'react';
import { ShareRestrictions } from 'services/OpenAccessLoginService';

/**
 * The restrictions of the Open Access share being viewed. Provided once they have been fetched, so
 * anything rendered beneath `RequireOpenAccessAuth` can rely on them; undefined outside Open Access.
 */
const ShareRestrictionsContext = createContext<ShareRestrictions | undefined>(undefined);
ShareRestrictionsContext.displayName = 'ShareRestrictionsContext';

export const useShareRestrictionsContext = (): ShareRestrictions | undefined => useContext(ShareRestrictionsContext);

export default ShareRestrictionsContext;
